import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { TermType } from 'src/app/model/term-type';

@Injectable({
  providedIn: 'root'
})
export class TermtypeEntityService extends EntityCollectionServiceBase<TermType> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('TermType', serviceElementsFactory);
  }
}
